export function formatPhone(raw) {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, 10)
  if (digits.length === 10) {
    return {
      formatted: `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`,
      isValid: true,
    }
  }
  if (digits.length >= 7) {
    return {
      formatted: `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`,
      isValid: false,
    }
  }
  if (digits.length >= 4) {
    return {
      formatted: `(${digits.slice(0, 3)}) ${digits.slice(3)}`,
      isValid: false,
    }
  }
  if (digits.length > 0) {
    return { formatted: `(${digits}`, isValid: false }
  }
  return { formatted: '', isValid: false }
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateEmail(raw) {
  const v = String(raw || '').trim()
  if (!v) return { isValid: false, message: '' }
  return {
    isValid: EMAIL_RE.test(v),
    message: EMAIL_RE.test(v) ? '' : 'Enter a valid email',
  }
}

export function personalizeTitle(
  fallback,
  { practiceName, firstOwnerFirstName } = {},
) {
  const practice = (practiceName || '').trim() || 'your practice'
  const name = (firstOwnerFirstName || '').trim() || 'you'
  return String(fallback || '')
    .replace(/\{practice\}/g, practice)
    .replace(/\{name\}/g, name)
}

// Expose the function name as a string literal so the symbol survives
// minification and can be located in the production bundle for
// deploy-verification greps.
personalizeTitle.displayName = 'personalizeTitle'

const ORDINAL_WORDS = [
  'First',
  'Second',
  'Third',
  'Fourth',
  'Fifth',
  'Sixth',
  'Seventh',
  'Eighth',
  'Ninth',
  'Tenth',
]

export function ordinalLabel(index, nounSingular, firstLabelOverride) {
  const n = Number(index) || 0
  if (firstLabelOverride && n === 0) return firstLabelOverride
  const noun = String(nounSingular || '').trim()
  if (n >= 0 && n <= 9) {
    return `${ORDINAL_WORDS[n]} ${noun}`
  }
  const cap = noun ? noun.charAt(0).toUpperCase() + noun.slice(1) : ''
  return `${cap} ${n + 1}`.trim()
}

export function extractEmailDomain(website) {
  const s = String(website || '').trim()
  if (!s) return null
  try {
    const hasProto = /^https?:\/\//i.test(s)
    const u = new URL(hasProto ? s : `https://${s}`)
    const host = u.hostname.replace(/^www\./i, '').toLowerCase()
    return host && host.includes('.') ? host : null
  } catch {
    return null
  }
}
